// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint:disable */
export const VERSION = {
    "version": "4.5.0",
    "short": "6c7f99f",
    "branch": "Detached: 6c7f99f9d3baf03e93cafc22b65fbed3b24a24d2",
    "date": "2026-9-7"
};
/* eslint:enable */
